import { register } from 'register-service-worker';

// Registers the single service worker (public/sw.js). Kept quiet on purpose — only
// real registration errors are logged; routine lifecycle events are not.
register('/sw.js', {
  // Root scope so the worker controls asset requests (e.g. /vite/assets/*)
  // regardless of which page first registers it. './' resolves against the
  // registering page, so a nested entry URL could otherwise narrow the scope.
  registrationOptions: { scope: '/' },
  updated() {
    // A new build is available; it will control the page on the next load.
  },
  error(error) {
    console.error('Service worker registration failed:', error);
  },
});
